<template>
  <div class="col-lg-4 col-md-6 box-col-4">
    <div class="card visitor-card">
      <div class="card-header pb-0">
        <div class="d-flex justify-content-between">
          <div class="flex-grow-1">
            <p class="square-after f-w-600 header-text-info">
              Total de Pedidos concluidos en el mes<i class="fa fa-circle"> </i>
            </p>
            <h4>{{ formattedTotalConcluidos }}</h4>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="profit-wrapper header-text-info icon-bg-info">
              <i class="fa fa-check"></i>
            </div>
            <h6 class="header-text-info">{{ formattedCompletionPercentage }}</h6>
            <p class="mb-0">{{ completionLabel }}</p>
          </div>
        </div>
        <div class="right-side icon-right-info">
          <i class="fa fa-user"></i>
          <div class="shap-block">
            <div class="rounded-shap animate-bg-primary"><i></i><i></i></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisitorCard',
  props: {
    totalConcluidos: {
      type: Number,
      default: 0,
    },
    completionPercentage: {
      type: Number,
      default: 0,
    },
    completionLabel: {
      type: String,
      default: 'Porcentaje sobre pedidos activos',
    },
  },
  computed: {
    formattedTotalConcluidos() {
      const value = Number(this.totalConcluidos) || 0
      return value.toLocaleString('es-MX')
    },
    formattedCompletionPercentage() {
      const value = Number(this.completionPercentage)
      if (Number.isFinite(value)) {
        return `${value.toFixed(2)}%`
      }
      return '0.00%'
    },
  },
}
</script>
